import 'angular';
import * as moment from 'moment';
import {ApprovalLevelConfig, ApprovalApprover, ApprovalStatus} from "../../approvals-types";
import {RootScope} from "../../../types/angular-types";
import {find} from 'lodash-es';

interface IScope extends RootScope {
    setDefaultDueDateIfNull: () => void;
    formData: { searchUserName: string };
    getLevelTitle: () => string;
    searchUsers: (query) => any;
    level: ApprovalLevelConfig;
    isApproverModifiable: (approver: ApprovalApprover) => boolean;
}

ApprovalLevelControllerFn.$inject = ['$scope', 'TypeaheadService', '$translate', '$log', '$q', '$rootScope'];
angular.module("GorillaBoy.Approvals")
.controller('ApprovalLevelController', ApprovalLevelControllerFn);

function ApprovalLevelControllerFn($scope: IScope, TypeaheadService: any, $translate: any, $log: ng.ILogService, $q: ng.IQService, $rootScope: RootScope) {

    $scope.formData = {
        searchUserName: ''
    };

    $scope.getFullName = $rootScope.getFullName;

    $scope.datePickerOptions = {
        minDate: new Date(),
        dateFormat: 'mm/dd/yy',
    };

    $scope.typeAheadSelect = function(item) {
        $log.debug("typeAheadSelect called" + JSON.stringify(item));
        $scope.formData.searchUserName = '';
        if (item && item.metadata && item.metadata.Id) {
            let approver: ApprovalApprover = {
                UserId: item.metadata.Id,
                Email: item.metadata.EmailAddress,
                GivenName: item.metadata.GivenName,
                Surname: item.metadata.Surname,
                ApproverKind: "USER",
                Level: $scope.level.LevelNumber
            }
            if (!find($scope.level.approvers, {UserId: approver.UserId})) {
                $scope.level.approvers.push(approver);
            }
        }
    };

    $scope.deletePrincipalClickHandler = function(userToBeRemoved: ApprovalApprover) {
        $scope.level.approvers = $scope.level.approvers.filter((approver: ApprovalApprover) => {
            return approver.UserId !== userToBeRemoved.UserId;
        });
    };

    $scope.searchUsers = function(query) {
        var deferred = $q.defer(),
            searchUsersParams = {
                excludeSelf: true,
                reuseLastSearchOnError: true,
                showQueryAsMatch: false
            };

        TypeaheadService.searchUsers(query, searchUsersParams).then(
            function resolveSuccess(userCollaboratorWrappers) {
                deferred.resolve(userCollaboratorWrappers);
            },
            function resolveFailure() {
                deferred.resolve([]);
            });

        return deferred.promise;
    };

    $scope.isApproverModifiable = (approver: ApprovalApprover) => {
        return approver.Status !== ApprovalStatus.APPROVED && approver.Status !== ApprovalStatus.REJECTED;
    }
}
